import { makeStyles } from "@mui/styles";
import { colors } from "../../../../theme/colors";

const { Grey } = colors;

const styles = {
  fieldPhoto: {
    width: 60,
    height: 40,
    objectFit: "cover",
    borderRadius: 4,
    cursor: "pointer",
  },
  dialogContent: {
    position: "relative",
    p: 4,
  },
  closeIcon: {
    position: "absolute",
    top: 0,
    right: 0,
  },
  imgDialog: {
    width: "100%",
    height: "auto",
    maxHeight: "85vh",
    objectFit: "cover",
    borderRadius: 8,
  },
  noImage: {
    width: 60,
    height: 40,
    objectFit: "cover",
    borderRadius: 4,
    cursor: "default",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: Grey[200],
  },
  noImageText: {
    color: Grey[500],
    fontSize: "12px",
    textAlign: "center",
  },
};

export const useStyles = makeStyles(styles);
export default styles;
